module.exports = "/lucky-balls/video/intro_al.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_al.mp4
// module id = 880
// module chunks = 0